//============================================================================
// Name        : scheduleReducer.ts
// Purpose     : Define store Schedule reducer
// Created     : 2019-08-09
// Author      : Senitron Team
// Copyright   : Copyright 2019 Senitron Corporation. All rights reserved.
//============================================================================

import { hideSOInspectDialog, IScheduleAction, IShowSOInspectDialogAction, IUpdateStateAction, showSOInspectDialog, updateState } from "../actions/scheduleActions";
import { IInspectSoItemsResp, IProduct, IScheduleState, ScheduleActions } from "../types";

const initialState: IScheduleState = {
    showAsLbs: true,
    showAsCases: true,
    showSOInspect: false,
    product: {} as IProduct,
    qtyOnHandCases: 0,
    qtyOnHandLbs: 0,
    storageUnit: null,
    pastDueSlice: [],
    scheduledSlice: [],
    scheduledSlice1: [],
    scheduledSlice2: [],
    scheduledSlice3: [],
    scheduledSlice4: [],
    soPdItems: [],
    soItems: [],
    soItems1: [],
    soItems2: [],
    soItems3: [],
    soItems4: [],

    inspectSO: {
        inspectSO: [],
        sos: []
    } as IInspectSoItemsResp,

    editScheduleUrl: ""
};

export default function(state: IScheduleState = initialState, action: IScheduleAction): IScheduleState {
    switch (action.type) {

        //====================================================================
        // Map Actions messages to Action functions
        //====================================================================

        case ScheduleActions.StoreInitialState:         return updateState(state, action as IUpdateStateAction);
        case ScheduleActions.UpdateState:               return updateState(state, action as IUpdateStateAction);
        case ScheduleActions.ShowSOInspectDialog:       return showSOInspectDialog(state, action as IShowSOInspectDialogAction);
        case ScheduleActions.HideSOInspectDialog:       return hideSOInspectDialog(state);

        //====================================================================

        default:
            return state;
    }
}
